module.exports = __webpack_public_path__ + "img/STEEM.92e34000.svg";